// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"6ce95238d082466c","7229":"d76a59bc0a5e721e"}[chunkId] + ".js";
};